import React, { ReactElement, useEffect, useRef, useState } from "react";
import './DropDown.css'
import {ReactComponent as Picked} from "./static/picked.svg";
import { DropDownListArray } from "./dropDownType/dropDownType";
import useOutside from "../../customHooks/useOutside";

interface DropDownProps {
    childrenDown?: ReactElement,
    childrenUp?: ReactElement,
    isActive: boolean,
    updateIsActive: Function,
    position?: object,
    optionArr: DropDownListArray[],
    defaultValue: string | number | null,
    onClickFunc: Function
    activeFinder?: boolean,
    placeholderFinder?: string
}

export default function DropDown({childrenDown, childrenUp, optionArr, isActive, updateIsActive, position, defaultValue, onClickFunc, activeFinder, placeholderFinder}: DropDownProps) {
    const refDropDown = useRef<HTMLDivElement | null>(null);
    const refDD = useOutside(() => updateIsActive(false))
    const refList = useRef<HTMLUListElement | null>(null);
    const [arrayOfList, setArrayOfList] = useState(optionArr);
    const [finderValue, setFinderValue] = useState('');

    const closeDD = () => {
        setFinderValue('')
        setArrayOfList(optionArr)
        updateIsActive(false)
    }

    const findListElement = (value: string) => {
        setFinderValue(value)
        const regExp = new RegExp (`${value}`, 'i')
        const matches = optionArr.filter(el => regExp.test(el.nameElement));
        setArrayOfList(matches)
    }
    
    useEffect(() => {
        setArrayOfList(optionArr)
    }, [optionArr])

    useEffect(() => {
        if (refList.current) {
            if (refList.current.clientHeight < refList.current.scrollHeight) {
                refList.current.style.overflowY = 'scroll';
            }
        }
    })

    const handlePickVariantList = (payload: DropDownListArray, index: number, e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        if (payload.isDisabled && (payload.isDisabled === true)){
            e.stopPropagation()
            return
        }
        onClickFunc({element: payload.nameElement, index: index})
        closeDD()
        e.stopPropagation()
    }
    
    return (
        <div ref={refDD} style={isActive ? position : {}} className={isActive ? "DropDown" : "hiddenDropDown"} >
            {childrenUp}
            { activeFinder && 
                <input type="text" value={finderValue} placeholder={placeholderFinder ?? 'Введите название'} className="DropDown__finder" onChange={(e) => findListElement(e.target.value)}/> }
            <ul ref={refList} className="DropDown__option-list" style={refDropDown.current ? {minWidth: `${refDropDown.current.offsetWidth}px`} : {}}>
                {
                    arrayOfList.length > 0 ?
                    arrayOfList.map((el, index) => {
                        if (el.isHidden) {
                            return null
                        } else {
                            return (
                                <li className="DropDown__option-el"
                                    onClick={(e) => {
                                        handlePickVariantList(el, index, e)
                                        // el.isDisabled ? e.preventDefault() :
                                        // onClickFunc({element: el, index: index})
                                        // closeDD()
                                        // e.stopPropagation()
                                    }} 
                                    key={index}><p className={`DropDown__option-el__p ${el.isDisabled ? 'DD_element-disabled' : ''}`}>{el.nameElement}</p>
                                    <span style={{visibility: defaultValue === index || defaultValue === el.nameElement ? 'visible' : 'hidden'}}>
                                        <Picked/>
                                    </span>
                                </li>
                            )
                        }
                    }) : <li className="DropDown__option-el__empty"><p>Совпадений не найдено</p></li>
                }
            </ul>
            {childrenDown}
        </div>
    )
}